
import { Button } from 'antd'
import { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons';

import VideoGuidesDetails from "./VideoGuidesDetails";
import VideoGuideList from "./VideoGuideList";

const VideoGuideView  = () => {

    let msg;
    const [visible, setVisible] = useState(false);
    const [hasUpdated, setHasUpdated] = useState(true);
    const [modalType, setModalType] = useState("Add New User Guide");

    const showModal = (record, type) => { 
        setVisible(record);
        setModalType(type);
    };

    return (
        <>
            <div className="content">
                <Button
                    className="add-button"
                    key="add-button-1"
                    type="primary"
                    onClick={() => showModal({}, "add")}
                    icon={<PlusOutlined />}
                >
                    {""} Add New
                </Button>
                <br /> <br />
                <VideoGuidesDetails
                    key={"a2"}
                    type={modalType}
                    setType={setModalType}
                    record={visible}
                    onShow={showModal}
                    hasUpdated={hasUpdated}
                    setHasUpdated={setHasUpdated}
                />
                <VideoGuideList
                    key={"guide-list"}
                    hasUpdated={hasUpdated}
                    setHasUpdated={setHasUpdated}
                    modalType={modalType}
                    setModalType={setModalType}
                    showModal={showModal}
                />
            </div>
        </>
    )
}

export default VideoGuideView;